import React from 'react';
import { Icons } from '../../utilities';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setShowPixelationWindowDialogue } from '../../redux/actions/pixelationHandler';
import {
  requestSampleIsClicked,
  setShowPixelationWarningField
} from '../../redux/fabricCanvasActions';
import { string } from '../../localization';
import '../../Containers/Body/DesignComponent/FabricCanvas/FabricCanvas.scss';
import './WarningView.scss';
import MediaQuery from 'react-responsive';

const WarningView = props => {
  const {
    nonPixelatedDimension,
    dispatchers,
    viewOnlyPreviewMode,
    supportsSample,
    isMultiWall
  } = props;

  return (
    <MediaQuery query='(min-width: 767px)'>
      <div
        className='warning-view'
        style={{
          pointerEvents: 'auto',
          top: isMultiWall ? '125px' : '0px'
        }}
      >
        <span className='d-flex'>
          <img
            src={Icons.pixelation_warning_icon_black}
            alt='warning-icon'
            className='warning-icon'
          />
          <div className='pixalation-warning'>
            <span
              style={{
                fontSize: '15px',
                background: 'rgb(254, 204, 47)',
                fontWeight: 'bold',
                color: 'rgb(0, 0, 0)'
              }}
            >
              {string.PIXELATION_WARNING_KEY}.
            </span>
            <span
              className='text-view'
              style={{
                marginLeft: '10px',
                fontSize: '13px',
                background: 'rgb(254, 204, 47)',
                color: 'rgb(0, 0, 0)'
              }}
            >
              {string.PIXELATION_WARNING_DESCRIPTION1_KEY}{' '}
              {string.formatString(
                string.PIXELATION_WARNING_DESCRIPTION2_KEY,
                nonPixelatedDimension.width,
                nonPixelatedDimension.height
              )}
              <button
                type='button'
                style={{
                  border: 'none',
                  background: 'none',
                  outline: 'none'
                }}
                className='learn-more'
                onClick={() =>
                  dispatchers.setShowPixelationWindowDialogue(true)
                }
              >
                {string.LEARN_MORE}
              </button>
            </span>
          </div>
        </span>
        <div className='btn-close-container'>
          {supportsSample && !viewOnlyPreviewMode ? (
            <button
              type='button'
              className='requestSample'
              onClick={dispatchers.requestSampleIsClicked}
            >
              {string.REQUEST_SAMPLE_KEY}
            </button>
          ) : null}
          <span>
            <button
              type='button'
              style={{
                border: 'none',
                background: 'none',
                outline: 'none'
              }}
              onClick={() => dispatchers.setShowPixelationWarningField(false)}
            >
              <img
                src={Icons.pixelation_warning_close_dark}
                alt='warning_close'
                style={{ marginLeft: '9px', cursor: 'pointer' }}
              />
            </button>
          </span>
        </div>
      </div>
    </MediaQuery>
  );
};

function mapStateToProps(state) {
  return {
    showRequestSampleWindow: state.fabricCanvas.showRequestSampleWindow,
    supportsSample: state.modal.storeData.supportsSample,
    showPixelationWarningField: state.fabricCanvas.showPixelationWarningField,
    nonPixelatedDimension: state.fabricCanvas.nonPixelatedDimension,
    viewOnlyPreviewMode: state.modal.envData.view_only_preview_mode
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: bindActionCreators(
      {
        requestSampleIsClicked,
        setShowPixelationWarningField,
        setShowPixelationWindowDialogue
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WarningView);
